import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: {
            // Navigation
            "nav_home": "Home",
            "nav_profile": "Profile",
            "nav_community": "Community",
            "nav_portfolio": "Portfolio",
            "nav_courses": "Courses",
            "nav_blog": "Blog",
            "nav_about": "About",
            "nav_portfolio": "Portfolio",

            // Profile Page
            "edit_profile": "Edit Profile",
            "save_changes": "Save Changes",
            "logout_reset": "Logout & Reset",
            "premium_member": "Premium Member",
            "upload_video": "Upload Profile Video",
            "change_video": "Change Video",
            "bio_default": "Full Stack Developer | Nexus Core",

            // Community Page
            "comm_title": "Nexus Community",
            "comm_subtitle": "Connect with other developers",
            "comm_placeholder": "What's on your mind?",
            "comm_post_btn": "Post",
            "comm_like": "Like",
            "comm_comment": "Comment",

            // General
            "welcome": "Welcome back",
            "loading": "Loading..."
        }
    },
    id: {
        translation: {
            // Navigasi
            "nav_home": "Beranda",
            "nav_profile": "Profil",
            "nav_community": "Komunitas",
            "nav_portfolio": "Portofolio",
            "nav_courses": "Kursus",
            "nav_blog": "Blog",
            "nav_about": "Tentang",
            "nav_portfolio": "Portofolio",

            // Halaman Profil
            "edit_profile": "Ubah Profil",
            "save_changes": "Simpan Perubahan",
            "logout_reset": "Keluar & Reset",
            "premium_member": "Anggota Premium",
            "upload_video": "Unggah Video Profil",
            "change_video": "Ganti Video",
            "bio_default": "Pengembang Full Stack | Nexus Core",

            // Halaman Komunitas
            "comm_title": "Komunitas Nexus",
            "comm_subtitle": "Terhubung dengan developer lain",
            "comm_placeholder": "Apa yang kamu pikirkan?",
            "comm_post_btn": "Kirim",
            "comm_like": "Suka",
            "comm_comment": "Komentar",

            // Umum
            "welcome": "Selamat datang kembali",
            "loading": "Memuat..."
        }
    }
};

i18n
    .use(LanguageDetector) // Mendeteksi bahasa browser user (ID atau EN)
    .use(initReactI18next) // Menghubungkan i18next dengan React
    .init({
        resources,
        fallbackLng: "en", // Jika deteksi gagal, otomatis pakai Bahasa Inggris
        debug: false, // Set ke true jika ingin melihat log error di console
        interpolation: {
            escapeValue: false // React sudah aman dari serangan XSS secara bawaan
        },
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage'] // Menyimpan pilihan bahasa user di browser
        }
    });

export default i18n;